import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  components: {
    Popover: {
      baseStyle: {
        // Chakra pins the positioner at z-index 10, which puts a portaled
        // popover under the template editor's side panel (99). Use the
        // theme's popover layer instead.
        popper: { zIndex: 'popover' },
      },
    },
  },
  styles: {
    global: function () {
      return {
        body: {
          fontFamily: `"Inter", sans-serif`,
        },
      };
    },
  },
});

export default theme;
